import AOS from "aos";
import "aos/dist/aos.css"; // Import the CSS for AOS
import React, { useEffect } from "react";
// import { InstitutionHeader } from "./components/InstitutionHeader";
import AchievementsSection from "./components/Sections/AchievementsSection";
import CampusLife from "./components/Sections/CampusLife";
import HighlightsSection from "./components/Sections/HighlightsSection";
import ImpressiveFacilities from "./components/Sections/ImpressiveFacilities";
import { InstitutionCarousel } from "./components/Sections/InstitutionCarousel";
import LibrariesSection from "./components/Sections/LibrariesSection";
import MessageCards from "./components/Sections/MessageCard";
import ProgramsSection from "./components/Sections/ProgramsSection";
import QuickLinks from "./components/Sections/QuickLinks";
import ScholarshipExam from "./components/Sections/ScholarshipExam";
import StaffExperienceSection from "./components/Sections/StaffExperienceSection";
import SuccessStories from "./components/Sections/SuccessStories";
import VisionMissionAnnouncements from "./components/Sections/VisionMissionAnnouncements";
import WhyUs from "./components/Sections/WhyUs";
import ChatBotWidget from "./Enquiry/components/FloatingNavigation.js";

export const InstitutionDomainTemplate = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    < >
      <ChatBotWidget />
      {/* Hero Carousel */}
      <InstitutionCarousel data-aos="fade-up" />

      {/* Why Us Section */}
      <WhyUs data-aos="fade-right" />

      {/* Highlights Section */}
      <HighlightsSection data-aos="fade-left" />

      {/* Libraries Section */}
      <LibrariesSection data-aos="fade-up" />

      {/* Campus Life Section */}
      <CampusLife data-aos="zoom-in" />
      <StaffExperienceSection />
      {/* Impressive Facilities Section */}
      <ImpressiveFacilities data-aos="fade-left" />


      {/* Achievements Section */}
      <AchievementsSection data-aos="fade-up" />

      {/* Vision & Mission Announcements */}
      <VisionMissionAnnouncements data-aos="fade-left" />

      {/* Success Stories Section */}
      <SuccessStories data-aos="fade-right" />

      {/* Message Cards Section */}
      <MessageCards data-aos="fade-up" />
      <ScholarshipExam data-aos="zoom-in" />

      {/* Programs Section */}
      <ProgramsSection data-aos="fade-up" />

      {/* Scholarship Exam Section */}
      <QuickLinks data-aos="fade-up" />

    </ >
  );
};
